import { render, staticRenderFns } from "./aPricingStrategyRuleDetail.vue?vue&type=template&id=991116c6&scoped=true"
import script from "./aPricingStrategyRuleDetail.vue?vue&type=script&lang=js"
export * from "./aPricingStrategyRuleDetail.vue?vue&type=script&lang=js"
import style0 from "./aPricingStrategyRuleDetail.vue?vue&type=style&index=0&id=991116c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991116c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDivider,VIcon})
